import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CounsellorBookings } from "../api/api";
import "../CounsellorAllPages/CounsellorBooking.css";

const CounsellorBooking = () => {
  const [bookingData, setBookingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const getBooking = useCallback(async () => {
    setIsLoading(true);
    const userData = localStorage.getItem("currentUser");
    const parsedUserData = JSON.parse(userData);
    const _id = parsedUserData?.id || parsedUserData?._id;

    try {
      const values = { counsellor_id: _id };
      const response = await CounsellorBookings(values);
      if (response?.data) {
        setBookingData(response.data);
      }
    } catch (error) {
      console.log("Error fetching bookings:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getBooking();
  }, [getBooking]);

  const goChatPage = (id) => {
    navigate(`/CounsellorSidebar/CounsellorChat/${id}`);
  };

  const renderBooking = (item) => (
    <div className="Bookingcard" key={item.id}>
      <div className="card-content">
        <div className="row">
          <span className="label">Booking ID:</span>
          <span className="value">{item.booking_id}</span>
        </div>
        <div className="row">
          <span className="label">User:</span>
          <span className="value">{item.user?.name || "N/A"}</span>
        </div>
        <div className="row">
          <span className="label">Date:</span>
          <span className="value">
            {moment(item.date).format("D MMMM YYYY")}
          </span>
        </div>
        <div className="row">
          <span className="label">Time:</span>
          <span className="value">{item.time}</span>
        </div>
        <div className="row">
          <span className="label">Status:</span>
          <span
            className="value"
            style={{
              color: item.status === "1" ? "green" : "red",
              fontWeight: "600",
            }}
          >
            {item.status === "1" ? "Booked" : "Expired"}
          </span>
        </div>
        {item.status === "1" && (
          <button
            className="chat-button"
            onClick={() => goChatPage(item.user?.id)}
          >
            💬 Chat Now
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className="scroll-wrapper">
        {isLoading ? (
          <div className="loader"></div>
        ) : bookingData.length > 0 ? (
          bookingData.map(renderBooking)
        ) : (
          <div className="empty">No Booking Available</div>
        )}
      </div>
    </div>
  );
};

export default CounsellorBooking;
